import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { CategoriesDataService } from './categories-data.service';
import { Category, CategoriesResult } from '../interfaces';
// import { SubCategoriesDataService } from './sub-categories-data.service';
// import { SubCategory, SubCategoriesResult } from '../interfaces';
// import { UsersDataService } from './users-data.service';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class RecipesColumnsService {

  public categories: Category[] = [];
  // public subCategories: SubCategory[] = [];
  public users: User[] = [];
  public statusesOptions = [{
    value: 'Draft',
    label: 'STATUSESDRAFT',
    css: 'primary'
  }, {
    value: 'Online',
    label: 'STATUSESONLINE',
    css: 'success'
  }, {
    value: 'Deactivated',
    label: 'STATUSESDEACTIVATED',
    css: 'warning'
  }, {
    value: 'Offline',
    label: 'STATUSESOFFLINE',
    css: 'danger'
  }, {
    value: 'Deleted',
    label: 'STATUSESDELETED',
    css: 'default'
  }, {
    value: 'Archived',
    label: 'STATUSESARCHIVED',
    css: 'info'
  }];

  public difficultyLevelOptions = [{
    value: 'Easy',
    label: 'DIFFICULTYLEVELF',
    css: 'primary'
  }, {
    value: 'Average',
    label: 'DIFFICULTYLEVELM',
    css: 'success'
  }, {
    value: 'Difficult',
    label: 'DIFFICULTYLEVELD',
    css: 'warning'
  }];

  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,
    private categoriesDataService: CategoriesDataService,
    // private subCategoriesDataService: SubCategoriesDataService,
    // private usersDataService: UsersDataService,

  ) {
    // this.getCategories()
    // this.getSubCategories()
    // this.getUsers()
  }

  // getCategories(offset: number = 0): void {
  //   const cacheKey: string = 'categories.cache'
  //   const cache: any = this.cache.get(cacheKey);
  //   if (cache !== null && offset === 0) {
  //     this.categories = cache.results
  //     return;
  //   }
  //   const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
  //   this.categoriesDataService.getCategories(parameters).subscribe((response: CategoriesResult|any) => {
  //     if (response !== null) {
  //       if (offset === 0) {
  //         this.categories = response.results;
  //       } else {
  //         this.categories = this.categories.concat(response.results);
  //       }
  //       if (response.inlineCount > this.categories.length) {
  //         offset = offset + parseInt(this.defaultParameters.limit + '', 10);
  //         this.getCategories(offset);
  //       }
  //       response.results = this.categories;
  //       this.cache.set(cacheKey, response);
  //     }
  //   });
  // }

  // getSubCategories(offset: number = 0): void {
  //   const cacheKey: string = 'subCategories.cache'
  //   const cache: any = this.cache.get(cacheKey);
  //   if (cache !== null && offset === 0) {
  //     this.subCategories = cache.results
  //     return;
  //   }
  //   const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
  //   this.subCategoriesDataService.getSubCategories(parameters).subscribe((response: SubCategoriesResult|any) => {
  //     if (response !== null) {
  //       if (offset === 0) {
  //         this.subCategories = response.results;
  //       } else {
  //         this.subCategories = this.subCategories.concat(response.results);
  //       }
  //       if (response.inlineCount > this.subCategories.length) {
  //         offset = offset + parseInt(this.defaultParameters.limit + '', 10);
  //         this.getSubCategories(offset);
  //       }
  //       response.results = this.subCategories;
  //       this.cache.set(cacheKey, response);
  //     }
  //   });
  // }

  // getUsers(offset: number = 0): void {
  //   const cacheKey: string = 'users.cache'
  //   const cache: any = this.cache.get(cacheKey);
  //   if (cache !== null && offset === 0) {
  //     this.users = cache.results
  //     return;
  //   }
  //   const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
  //   this.usersDataService.getUsers(parameters).subscribe((response: UsersResult|any) => {
  //     if (response !== null) {
  //       if (offset === 0) {
  //         this.users = response.results;
  //       } else {
  //         this.users = this.users.concat(response.results);
  //       }
  //       if (response.inlineCount > this.users.length) {
  //         offset = offset + parseInt(this.defaultParameters.limit + '', 10);
  //         this.getUsers(offset);
  //       }
  //       response.results = this.users;
  //       this.cache.set(cacheKey, response);
  //     }
  //   });
  // }

  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('recipes.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'title', sortField: 'name', title: this.translate.instant('NAME'), show: (this.navigation.getParamValue('recipes.title.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'titleAr', sortField: 'titleAr', title: this.translate.instant('NAMEAR'), show: (this.navigation.getParamValue('recipes.titleAr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'titleFr', sortField: 'titleFr', title: this.translate.instant('NAMEFR'), show: (this.navigation.getParamValue('recipes.titleFr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'imagePath', sortField: 'imagePath', title: this.translate.instant('CONTENT.MOBILEPICTURE'), show: (this.navigation.getParamValue('recipes.imagePath.showFiled', true) && true), displayInList: true, type: 'imgValue'},

      { field: 'description', sortField: 'description', title: this.translate.instant('DESCRIPTION'), show: (this.navigation.getParamValue('recipes.description.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionAr', sortField: 'descriptionAr', title: this.translate.instant('DESCRIPTIONAR'), show: (this.navigation.getParamValue('recipes.descriptionAr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionFr', sortField: 'descriptionFr', title: this.translate.instant('DESCRIPTIONFR'), show: (this.navigation.getParamValue('recipes.descriptionFr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'duration', sortField: 'duration', title: this.translate.instant('DURATION'), show: (this.navigation.getParamValue('recipes.duration.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      
      { field: 'carbs', sortField: 'carbs', title: this.translate.instant('CARBS'), show: (this.navigation.getParamValue('recipes.carbs.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'proteins', sortField: 'proteins', title: this.translate.instant('PROTEINS'), show: (this.navigation.getParamValue('recipes.proteins.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'calories', sortField: 'calories', title: this.translate.instant('CALORIES'), show: (this.navigation.getParamValue('recipes.calories.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      // { field: 'applicationId', sortField: 'applicationId', title: this.translate.instant('applicationId'), show: (this.navigation.getParamValue('gift.applicationId.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'application', sortField: 'application', title: this.translate.instant('application'), show: (this.navigation.getParamValue('recipes.application.showFiled', false) && true), displayInList: true, type: 'textValue'},

   
      { field: 'isActive', sortField: 'isActive', title: this.translate.instant('CONTENT.SATUTS'), show: (this.navigation.getParamValue('applications.isActive.showFiled', false) && true), displayInList: true, type: 'colorValue'},
      { field: 'actions', title: this.translate.instant('CONTENT.ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
